var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_6133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 25.5,
    width: 6,
    height: 16,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 28H22L26.2375 32.2375C27.7166 33.7166 27.5953 36.1493 25.9764 37.4739V37.4739C24.5706 38.6241 22.5219 38.5219 21.2375 37.2375L18 34",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 37.5L21.6803 44.5082C23.7036 45.7222 26.2485 45.6474 28.197 44.3167L43.7682 33.6827C44.7463 33.0147 45.0472 31.7075 44.4595 30.6792V30.6792C43.9065 29.7113 42.7329 29.2877 41.6891 29.6791L27.5 35",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.593 26C39.4761 20.4336 38.9343 12.7177 33.9677 7.7511C28.3929 2.17636 19.3545 2.17636 13.7797 7.7511C13.2937 8.23717 12.85 8.74957 12.4487 9.28371C10.2006 12.276 9.28245 15.9505 9.69436 19.5",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.6667C22.0668 12.6667 20.5 13.7108 20.5 15C20.5 16.2892 22.0668 17.3333 24 17.3333C25.9332 17.3333 27.5 18.3775 27.5 19.6667C27.5 20.9558 25.9332 22 24 22M24 12.6667C25.295 12.6667 26.4267 13.1357 27.0322 13.8333M24 12.6667V11.5M24 22C22.705 22 21.5733 21.531 20.9678 20.8333M24 22V23.1667",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_6133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoe);
export default __webpack_public_path__ + "static/media/roe.77fa7941592c4f246cc9323a9b447eb4.svg";
export { ForwardRef as ReactComponent };